/* eslint-disable no-undef */
<template>
  <v-app id="inspire">
    <v-app-bar app color="white" flat>
      <v-tabs centered class="ml-n9" color="grey darken-1">
        <v-tab @click="ruta('chat')">Chat</v-tab>
        <v-tab @click="ruta('')">Info</v-tab>
        <v-tab
          v-if="
            !uidcliente &&
            logueado.cargo !== 'Perito' &&
            logueado.cargo !== 'Coordinador Perito'
          "
          @click="ruta('gestionar')"
          >Gestionar</v-tab
        >
        <v-tab
          @click="ruta('mapa')"
          v-if="
            logueado.cargo !== 'Perito' &&
            logueado.cargo !== 'Coordinador Perito'
          "
          >Geoloc</v-tab
        >
        <v-tab
          v-if="
            datosCaso.solicitud_perito &&
            (logueado.cargo === 'Perito' ||
              logueado.cargo === 'Coordinador Perito' ||
              logueado.cargo === 'Coordinador Investigador' ||
              logueado.cargo === 'Investigador')
          "
          @click="ruta('chat_perito')"
          >Chat Perito</v-tab
        >
        <v-tab
          v-if="
            datosCaso.solicitud_dibujante &&
            (logueado.cargo === 'Coordinador Investigador' ||
              logueado.cargo === 'Dibujante' ||
              logueado.cargo === 'Administrador' ||
              logueado.cargo === 'Investigador')
          "
          @click="ruta('chat_dibujante')"
          >Chat Dibujante</v-tab
        >
      </v-tabs>
      <v-btn
        v-if="uidUser"
        title="Regresar"
        color="primary"
        @click="Regresar"
        type="button"
        ><v-icon>mdi-reply-all</v-icon></v-btn
      >
      <v-btn v-if="uidcliente" @click="logOut" color="primary" type="button"
        >Salir</v-btn
      >
    </v-app-bar>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <v-col cols="12" sm="12">
            <v-alert v-if="!gps" color="orange" dense prominent type="info"
              >Para ejecutar este sistema es necesario encender la geo
              localización de tu dispositivo.</v-alert
            >
            <v-sheet min-height="70vh" rounded="lg">
              <router-view></router-view>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../../firebase";
import { mapActions } from "vuex";
import moment from "moment-timezone";

export default {
  data() {
    return {
      gps: true,
      usuariosChat: [],
      usuariosChatPerito: [],
      usuariosChatDibujante: [],
      datosCaso: {},
      ciudadesId: [],
      investigadoresDisponibles: [],
      cargos: ["Administrador", "Coordinador Contact Center"],
      registration_ids: [],
      investigadorAsignado: {},
      bogotaCiu: [
        "vDFBW7W0zvFECKkWnlUz",
        "EzbquhR0gy7P2VILCakG",
        "Dd9KBtqUnMpfJuzp9OMT",
      ],
    };
  },
  methods: {
    ...mapActions("notification", ["EnviarNotificaciones"]),
    async ruta(e) {
      this.chatUsuarioOnline(e);
      this.chatPeritoUsuarioOnline(e);
      this.chatDibujanteUsuarioOnline(e);
      this.$router
        .push(`/gestionar-caso/${this.$route.params.id}/${e}`)
        .catch(() => {});
    },
    async chatUsuarioOnline(e) {
      db.collection("chats")
        .where("uidcaso", "==", this.$route.params.id)
        .get()
        .then((resul) => {
          const res = resul.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          if (
            !res ||
            res.length === 0 ||
            !res[0] ||
            !Array.isArray(res[0].users)
          ) {
            // En algunos casos (p.ej. casos de Salesforce) el chat normal aún no existe.
            return;
          }
          if (localStorage.getItem("user")) {
            const userId = this.logueado?.id;
            if (!userId) return;
            this.usuariosChat = res[0].users.map((x) => {
              if (x._id == userId) {
                x.status.state = e == "chat" ? "online" : "offline";
              }
              return x;
            });
          } else {
            // console.log("cliente");
            this.usuariosChat = res[0].users.map((x) => {
              if (x._id == localStorage.getItem("cliente")) {
                x.status.state = e == "chat" ? "online" : "offline";
              }
              return x;
            });
          }
          db.collection("chats")
            .doc(res[0].id)
            .update({ users: this.usuariosChat });
        });
    },
    async chatPeritoUsuarioOnline(e) {
      let cargo =
        this.logueado.cargo === "Perito" ||
        this.logueado.cargo === "Coordinador Perito" ||
        this.logueado.cargo === "Coordinador Investigador" ||
        this.logueado.cargo === "Dibujante" ||
        this.logueado.cargo === "Investigador";

      if (!this.datosCaso.solicitud_perito) {
        return;
      }
      if (!cargo) {
        return;
      }

      db.collection("chatsperito")
        .where("uidcaso", "==", this.$route.params.id)
        .get()
        .then((resul) => {
          const res = resul.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          if (
            !res ||
            res.length === 0 ||
            !res[0] ||
            !Array.isArray(res[0].users)
          ) {
            return;
          }
          if (localStorage.getItem("user")) {
            const userId = this.logueado?.id;
            if (!userId) return;
            this.usuariosChatPerito = res[0].users.map((x) => {
              if (x._id == userId) {
                x.status.state = e == "chat_perito" ? "online" : "offline";
              }
              return x;
            });
          }
          db.collection("chatsperito")
            .doc(res[0].id)
            .update({ users: this.usuariosChatPerito });
        });
    },
    async chatDibujanteUsuarioOnline(e) {
      let cargo =
        this.logueado.cargo === "Coordinador Investigador" ||
        this.logueado.cargo === "Dibujante" ||
        this.logueado.cargo === "Investigador";

      if (!this.datosCaso.solicitud_dibujante) {
        return;
      }
      if (!cargo) {
        return;
      }

      db.collection("chatsdibujante")
        .where("uidcaso", "==", this.$route.params.id)
        .get()
        .then((resul) => {
          const res = resul.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          if (
            !res ||
            res.length === 0 ||
            !res[0] ||
            !Array.isArray(res[0].users)
          ) {
            return;
          }
          if (localStorage.getItem("user")) {
            const userId = this.logueado?.id;
            if (!userId) return;
            this.usuariosChatDibujante = res[0].users.map((x) => {
              if (x._id == userId) {
                x.status.state = e == "chat_dibujante" ? "online" : "offline";
              }
              return x;
            });
          }
          db.collection("chatsdibujante")
            .doc(res[0].id)
            .update({ users: this.usuariosChatDibujante });
        });
    },
    logOut: function () {
      this.$store.dispatch("ActualizarLoginCliente", {
        id: this.$route.params.id,
        login: false,
      });
      this.$store.commit("salirCliente");
      this.$router
        .push(`/login/auth-cliente/${this.$route.params.id}`)
        .catch(() => {});
    },
    Regresar() {
      this.$router.push("/casos").catch(() => {});
    },
    async InfoCaso() {
      try {
        const casoId = (
          this.$route?.params?.id ||
          localStorage.getItem("id") ||
          ""
        ).trim();
        if (!casoId) {
          console.error("ID de caso vacío en GestionarCaso.vue");
          return;
        }
        db.collection("casos")
          .doc(casoId)
          .onSnapshot(async (doc) => {
            if (doc.exists) {
              this.datosCaso = { ...doc.data(), id: doc.id };
              if (this.bogotaCiu.includes(this.datosCaso.uidciudad || "")) {
                console.log("Caso que se asignara automaticamente");
                await this.AsignarInvestigadorAutomaticamente();
              }
            } else {
              console.error("No se encontró el documento.");
            }
          });
      } catch (error) {
        console.error("Error al obtener datos del caso:", error);
      }
    },
    async AsignarInvestigadorAutomaticamente() {
      /* await this.BuscarCiudadCaso(
        this.datosCaso?.ciudad_siniestro?.toUpperCase()
      );
      if (this.ciudadesId.length > 0) {
        await this.BuscarInvetigadores();
      } */
      await this.BuscarInvetigadores();

      if (this.investigadoresDisponibles.length > 0) {
        const resultado = await Promise.all(
          this.investigadoresDisponibles.map(
            async ({ lat, long, id, disponibilidad, identificacion }) => {
              const distancia = await this.CalcularDistanciaHaversine(
                lat,
                long
              );
              return {
                distancia,
                id,
                disponibilidad,
                identificacion,
              };
            }
          )
        );
        const resultadoOrdenado = resultado.sort((a, b) => {
          if (a.distancia < b.distancia) return -1;
          if (a.distancia > b.distancia) return 1;
          if (
            a.disponibilidad === "Activo en espera" &&
            b.disponibilidad !== "Activo en espera"
          ) {
            return -1;
          }
          if (
            a.disponibilidad !== "Activo en espera" &&
            b.disponibilidad === "Activo en espera"
          ) {
            return 1;
          }
          return 0;
        });
        const investigadoresFiltroKilometros = resultadoOrdenado.filter(
          (a) => a.distancia < 30
        );
        if (investigadoresFiltroKilometros.length === 0) {
          console.log("No hay investigador en 30 kilómetros");
          return;
        }
        let investigadorId = investigadoresFiltroKilometros[0].id;
        if (
          investigadorId &&
          !this.datosCaso?.uidinvestigador &&
          localStorage.getItem("cliente") &&
          localStorage.getItem("cliente") !== ""
        ) {
          this.investigadorAsignado = investigadoresFiltroKilometros[0];
          console.log("Asignar a: ", investigadorId, this.investigadorAsignado);
          await this.notificarSocket();
          await this.AsignarInvestigadorCaso(investigadorId);
        }
      }
    },
    async AsignarInvestigadorCaso(id) {
      await db
        .collection("casos")
        .doc(this.datosCaso?.id)
        .update({
          uidinvestigador: id,
          // Registrar quién realizó la asignación automática (si hay sesión de usuario)
          uidasignador: this.logueado?.id || null,
          // Fecha y hora en la que el sistema asigna automáticamente el caso
          horadeasignacion: new Date(),
        });
      const result = await db
        .collection("casos")
        .where("uidinvestigador", "==", id)
        .where("archivado", "==", false)
        .where("estado", "not-in", [
          "Cancelado",
          "Conciliado",
          "No conciliado",
          "CERRADO",
        ])
        .get();
      const nuevoEstadoUsuario =
        result.size > 1 ? "Activo multiple" : "Activo ocupado";
      console.log("nuevoEstadoUsuario ", nuevoEstadoUsuario);

      const updateUser = await db
        .collection("usuarios")
        .doc(id)
        .update({ disponibilidad: nuevoEstadoUsuario });

      const resultUpdateUser = updateUser.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // se guarda la trazabilidad del caso
      this.$store.dispatch("trazabilidadCaso", {
        descripcion: `El sistema ha asignado un investigador al caso`,
        uidcaso: this.datosCaso?.id,
        uidcreador: id,
      });
      const cargo = "Investigador";
      const token = resultUpdateUser?.tokenPush || "";
      const name = resultUpdateUser?.nombres || "";
      // se guarda la trazabilidad del estado del usuario
      this.$store.dispatch("trazabilidadEstadoUsuarios", {
        descripcion: `Estado actualizado por el sistema`,
        estado: nuevoEstadoUsuario,
        uidcaso: this.datosCaso?.id,
        cargo: "Investigador",
        uidcreador: id,
        uidusuario: id,
      });
      const url = `https://digipats.com.co/gestionar-caso/${this.datosCaso?.id}`;
      // await this.tokenClienteContact();
      await this.consultarTokens();
      if (token) {
        this.registration_ids = [...this.registration_ids, token];
      }
      const title = "CASO ASIGNADO";
      const msj = `EL ${cargo ? cargo.toUpperCase() : cargo} ${
        name ? name.toUpperCase() : name
      } HA SIDO ASIGNADO.`;
      await this.EnviarNotificaciones({
        registration_ids: this.registration_ids,
        title,
        message: msj,
        url,
      });
    },
    async notificarSocket() {
      moment.tz.setDefault("America/Bogota");
      const identification = this.investigadorAsignado.identificacion;
      const caso = this.datosCaso.caso;
      const fechaActual = moment().format("YYYY-MM-DD HH:mm:ss");
      await db.collection("notificaciones").add({
        cedula: identification,
        caso,
        momento: "Asignación de caso - automático",
        fechahora: fechaActual,
      });
    },
    async BuscarInvetigadores() {
      try {
        const querySnapshot = await db
          .collection("usuarios")
          .where("cargo", "==", "Investigador")
          .where("estado", "==", true)
          .where("disponibilidad", "in", ["Activo en espera"])
          // .where("ciudades", "in", [...this.ciudadesId])
          .get();

        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            const { lat, long, disponibilidad, ciudades, identificacion } =
              doc.data();
            if (typeof lat === "number" && typeof long === "number") {
              this.investigadoresDisponibles = [
                {
                  id: doc.id,
                  lat,
                  long,
                  disponibilidad,
                  ciudades,
                  identificacion,
                },
                ...this.investigadoresDisponibles,
              ];
            }
          });
        }
      } catch (error) {
        console.log("Error al buscar la ciudad");
      }
    },
    ConvertirGradosRadianes(degrees) {
      return degrees * (Math.PI / 180);
    },
    async CalcularDistanciaHaversine(lat2, lon2) {
      const localizacion = this.datosCaso?.localizacion;
      if (!localizacion) {
        console.log("El caso aun no tiene coordenadas");
        return;
      }
      const { _lat: lat1, _long: lon1 } = localizacion;
      const R = 6371; // kilometros
      // const R = 6371000; // metros
      const dLat = this.ConvertirGradosRadianes(lat2 - lat1);
      const dLon = this.ConvertirGradosRadianes(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(this.ConvertirGradosRadianes(lat1)) *
          Math.cos(this.ConvertirGradosRadianes(lat2)) *
          Math.sin(dLon / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },
    async BuscarCiudadCaso(searchQuery) {
      try {
        const querySnapshot = await db
          .collection("ciudades")
          .where("ciudad", ">=", searchQuery)
          .where("ciudad", "<=", searchQuery + "\uf8ff")
          .get();
        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            this.ciudadesId = [...this.ciudadesId, doc.id];
          });
        }
      } catch (error) {
        console.log("Error al buscar la ciudad");
      }
    },
    async consultarTokens() {
      try {
        const usuarios = await db
          .collection("usuarios")
          .where("cargo", "in", this.cargos)
          .get();

        const objUsuNotificar = usuarios.docs.map((e) => ({
          ...e.data(),
        }));

        const usu = objUsuNotificar
          .filter((e) => {
            return e.tokenPush;
          })
          .map((u) => {
            return u.tokenPush;
          });
        if (usu.length > 0) {
          this.registration_ids = [
            ...usu,
            this.token_cliente,
            this.token_contac,
          ];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async tokenClienteContact() {
      try {
        const objCaso = await db
          .collection("casos")
          .doc(this.datosCaso?.id)
          .get();
        const { uidconductor, uidcontactcenter } = objCaso.data();
        if (uidconductor) {
          const objCliente = await db
            .collection("clientes")
            .doc(uidconductor)
            .get();
          const { tokenPush } = objCliente.data();
          if (tokenPush) {
            this.token_cliente = tokenPush;
          }
        }

        if (uidcontactcenter) {
          const objContact = await db
            .collection("usuarios")
            .doc(uidcontactcenter)
            .get();
          const { tokenPush } = objContact.data();
          if (tokenPush) {
            this.token_contac = tokenPush;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    uidcliente() {
      return localStorage.getItem("cliente");
    },
    uidUser() {
      return localStorage.getItem("user");
    },
  },
  async created() {
    this.$store.commit("authData");
    await this.InfoCaso();
  },
  watch: {
    "$store.state.gps": function () {
      this.gps = this.$store.state.gps;
    },
  },
};
</script>
<style src="./Caso.scss" lang="scss"></style>
